/** @jsxImportSource @emotion/react */
import { Box } from 'grommet'

import TagChip from 'components/TagChip'
import { ExistingGroupWithTags } from 'db-tables'

import GroupTitle from './GroupTitle'
import { GroupDateInfo } from './GroupDateInfo'
import GroupDescription from './GroupDescription'

type Props = {
  group: ExistingGroupWithTags
  linkResults?: boolean
}
export default function GroupDescriptionInfo({ group, linkResults = false }: Props) {
  return (
    <Box
      pad={{ bottom: 'none', horizontal: 'medium' }}
      height={{ min: 'auto' }}
      gap="small"
      width="large">
      <GroupTitle group={group} linkResults={linkResults} />
      {group.description && (
        <Box>
          <GroupDescription alignSelf="center" textAlign="center" group={group} />
        </Box>
      )}
      {group.tags.length > 0 && (
        <Box direction="row" wrap justify="center">
          {group.tags.map(({ tag }) => (
            <TagChip key={tag.id} {...tag} />
          ))}
        </Box>
      )}
      {group.created_at && (
        <GroupDateInfo
          color="gray"
          size="xsmall"
          alignSelf="center"
          date={group.start_time ?? group.created_at}
        />
      )}
    </Box>
  )
}
